/* Pivot : precommande STOQ
   1) La barre sticky Add to cart suit le bouton principal STOQ (texte + style Order)
   2) La ligne "In production" affiche la date d'expedition ecrite dans STOQ (ex. In production · Shipping: ...) */
(function () {
  function getMain() {
    var bar = document.querySelector('sticky-atc-bar');
    var pid = bar ? bar.getAttribute('data-product-id') : null;
    var mainForm = pid
      ? document.querySelector('.main-product-form[data-product-id="' + pid + '"]')
      : document.querySelector('.main-product-form');
    if (!mainForm) return null;
    var info = mainForm.closest('product-info') || mainForm.closest('section') || document.body;
    return { bar: bar, mainForm: mainForm, info: info, main: mainForm.querySelector('[name="add"]') };
  }

  /* 1) Barre sticky */
  function syncSticky(el) {
    if (!el.bar || !el.main) return;
    var sticky = el.bar.querySelector('[name="add"]');
    if (!sticky) return;
    var pre = el.main.classList.contains('restock-rocket-preorder-button');
    if (sticky.classList.contains('restock-rocket-preorder-button') !== pre) {
      sticky.classList.toggle('restock-rocket-preorder-button', pre);
    }
    if (!pre) return;
    var ms = el.main.querySelector('span');
    var ss = sticky.querySelector('span');
    var text = (ms || el.main).textContent.trim();
    if (ss && text && ss.textContent.trim() !== text) ss.textContent = text;
    if (sticky.disabled !== el.main.disabled) sticky.disabled = el.main.disabled;
  }

  /* 2) Date d'expedition dans la ligne In production */
  function getShipping(el) {
    var details = el.mainForm.querySelectorAll('.restock-rocket-preorder-description .preorder-detail-text');
    for (var i = 0; i < details.length; i++) {
      var t = details[i].textContent.replace(/\s+/g, ' ').trim();
      if (t) return t;
    }
    var input = el.mainForm.querySelector('input[name="properties[Shipping]"]');
    if (input && input.value.trim()) return 'Shipping: ' + input.value.trim();
    return '';
  }

  function syncShipping(el) {
    var inv = el.info.querySelector('.product__inventory--in-production .product__inventory-text');
    if (!inv) return;
    if (!inv.hasAttribute('data-pv-base')) inv.setAttribute('data-pv-base', inv.textContent.trim());
    var base = inv.getAttribute('data-pv-base');
    var shipping = getShipping(el);
    var wanted = shipping ? base + ' · ' + shipping : base;
    if (inv.textContent.trim() !== wanted) inv.textContent = wanted;
  }

  function sync() {
    var el = getMain();
    if (!el) return;
    syncSticky(el);
    syncShipping(el);
  }

  var observing = false;
  function init() {
    sync();
    if (observing) return;
    var el = getMain();
    if (!el) return;
    observing = true;
    var opts = { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['class', 'disabled', 'value'] };
    var mo = new MutationObserver(sync);
    mo.observe(el.info, opts);
    if (el.bar) mo.observe(el.bar, opts);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  window.addEventListener('load', init);
  setTimeout(init, 1500);
  setTimeout(sync, 3000);
})();
